import { newsApi } from './api';
import {
    ADD_JOB_ENDPOINT,
    GET_JOB_ENDPOINT,
    GET_JOB_STAS_ENDPOINT,
    JOB_EDIT_ENDPOINT,
    REMOVE_JOB_ENDPOINT
} from "./apiConstant";

export const PermitService = newsApi.injectEndpoints({
    endpoints: (build) => ({
        getPermits: build.query({
            query: ({ pagination }) => ({
                url: `permits${pagination && pagination}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetPermitsQuery,
} = PermitService